import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "form","password","passwordConfirm","passwordToggleHide","passwordToggleShow","passwordConfirmToggleHide","passwordConfirmToggleShow","matchError","match" ];
  static classes = ["hide", "errorm"];
  static values = {validateurl: String};

  password_toggle(event){
    const params = event.params;
    let input;
    let showIcon;
    let hideIcon;
    switch (params.column) {
      case "new":
        input = this.passwordTarget;
        showIcon = this.passwordToggleShowTarget;
        hideIcon = this.passwordToggleHideTarget;
        break;
      case "confirm":
        input = this.passwordConfirmTarget;
        showIcon = this.passwordConfirmToggleShowTarget;
        hideIcon = this.passwordConfirmToggleHideTarget;
    }
    //if password hide
    if(showIcon.classList.contains(this.hideClass)){
      input.type = "text";
    }else {
      input.type = "password";
    }
    showIcon.classList.toggle(this.hideClass);
    hideIcon.classList.toggle(this.hideClass);
  }

  passwordMatch(event){
    if (this.passwordConfirmTarget.value != null){
      if(this.passwordConfirmTarget.value != this.passwordTarget.value){
        this.matchErrorTarget.classList.remove(this.hideClass);
        this.matchTarget.classList.add(this.hideClass);
      }else{
        this.matchErrorTarget.classList.add(this.hideClass);
        this.matchTarget.classList.remove(this.hideClass);
      }
    }
  }
  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    formData.delete("_method");
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

}
